// extracted by mini-css-extract-plugin
module.exports = {"common-label":"CommonLabel_common-label_3y4EU","hinge":"CommonLabel_hinge_1lbew","fadeInBottomLeft":"CommonLabel_fadeInBottomLeft_1jYgC"};